import {
  canViewCustomerReceivables,
  canManageCustomerBilling,
} from '@/lib/customer-receivables-access'

export function canViewStatements(ability: MoneyAbility) {
  return ability.can('view', 'customers') && canViewCustomerReceivables(ability)
}
export function canRunStatements(ability: MoneyAbility) {
  return (
    canViewStatements(ability) &&
    ability.can('edit', 'customers') &&
    canManageCustomerBilling(ability)
  )
}
export function canViewMoney(ability: MoneyAbility, context: CashDrawerVisibility = {}) {
  return (
    ability.can('list', 'transactions') ||
    canViewStatements(ability) ||
    canOperateCashDrawers(ability, context) ||
    canEnableCashDrawerTracking(ability, context) ||
    ability.can('list', 'cash-drawer-reports')
  )
}

interface MoneyAbility {
  can: (action: string, subject: string) => boolean
}
// Navigation passes the current organization, which is null while it loads.
interface CashDrawerVisibility {
  organization?: { cash_drawer_tracking_enabled?: boolean } | null
}
export function canOperateCashDrawers(
  ability: MoneyAbility,
  { organization }: CashDrawerVisibility = {}
) {
  return (
    organization?.cash_drawer_tracking_enabled === true && ability.can('operate', 'cash-drawers')
  )
}

export function canEnableCashDrawerTracking(
  ability: MoneyAbility,
  { organization }: CashDrawerVisibility = {}
) {
  return (
    organization?.cash_drawer_tracking_enabled === false &&
    ability.can('view', 'cash-drawer-settings') &&
    ability.can('edit', 'cash-drawer-settings')
  )
}
